var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className || 'default',attrs:{"id":"progress-bar"}},[_c('progress',{attrs:{"max":_vm.maxValue},domProps:{"value":_vm.value}})])}
var staticRenderFns = []

export { render, staticRenderFns }